<p>Selecione o destino do produto:</p>
<form [formGroup]="form">
  <mat-form-field class="group">
    <mat-label>Setor</mat-label>
    <input type="text"
           placeholder="Setor"
           aria-label="Number"
           matInput
           formControlName="groundGroup"
           [matAutocomplete]="groundGroupAuto">
    <mat-autocomplete
      (closed)="groundGroupAutoClosed()"
      autoActiveFirstOption #groundGroupAuto="matAutocomplete" [displayWith]="displayedGroundGroup">
      <mat-option [value]="groundGroup"
                  *ngFor="let groundGroup of filteredGroundGroups"
                  (onSelectionChange)="onChangeSector($event)">{{ groundGroup.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="group">
    <mat-label>Posição</mat-label>
    <input type="text"
           placeholder="Posição"
           matInput
           formControlName="position"
           [matAutocomplete]="addressAuto"
    >
    <mat-autocomplete
      autoActiveFirstOption
      #addressAuto="matAutocomplete"
      [displayWith]="displayedPosition"
      (closed)="groundPositionAutoClosed()">
      <mat-option *ngFor="let groundPosition of filteredGroundPosition"
        [value]="groundPosition"
        [disabled]="groundPosition.disabled"
        [matTooltip]="groundPositionOptionTooltip(groundPosition.disabled)"
        (onSelectionChange)="onPositionSelected($event)">
        {{ groundPosition.isSuggested ? 'Seção recomendada: ' + groundPosition.label : groundPosition.label }}
        <span class="level-info">
          {{ groundPosition.levelInfo }}
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-checkbox color="primary" class="select-level-checkbox"
    formControlName="levelSelection"
    (change)="onLevelSelectionChange($event)"
    [checked]="isLevelSelectionEnabled">
    Selecionar nível
  </mat-checkbox>
  <mat-form-field class="group" *ngIf="isLevelSelectionEnabled">
    <mat-label>Nível</mat-label>
    <input type="text"
           placeholder="Nível"
           aria-label="Number"
           matInput
           formControlName="level"
           [matAutocomplete]="levelAuto">
    <mat-autocomplete [displayWith]="displayedLevel" autoActiveFirstOption #levelAuto="matAutocomplete">
      <mat-option [value]="level" *ngFor="let level of availableLevels">
        {{ level.name || '---' }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
